import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  public currentLayout = signal<string|undefined>(undefined);
  public showPublicBurger = signal<boolean>(false);
}
